<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <create-edit-funcionario-dialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <create-edit-senha-funcionario-dialog :item="item" v-model="editSenhaDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <funcionarios-data-table ref="dataTable"
                            @click:editSenha="editarSenha"
                             @click:edit="editar"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
  </base-view>

</template>

<script>
import FuncionariosDataTable from "../../components/shared/datatables/FuncionariosDataTable";
import BaseView from "../BaseView";
import {remove} from "../../api/funcionarios";
import CreateEditFuncionarioDialog from "../../components/shared/dialogs/CreateEditFuncionarioDialog";
import CreateEditSenhaFuncionarioDialog from "../../components/shared/dialogs/CreateEditSenhaFuncionarioDialog";
import {mapActions,mapGetters} from "vuex";
import {ApiError} from "../../api/core";

export default {
  name: "index",
  components: {CreateEditFuncionarioDialog, CreateEditSenhaFuncionarioDialog, BaseView, FuncionariosDataTable},
  data() {
    return {
      item: null,
      editDialogOpened: false,
      editSenhaDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Nome',
          column: 'nome',
          type: 'text'
        },
        {
          name: 'Login',
          column: 'login',
          type: 'text'
        },
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {};
      this.editDialogOpened = true;
    },
    editar(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.editDialogOpened = true;
    },
    editarSenha(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.editSenhaDialogOpened = true;
    },
    async remover({id}) {
      try {
        await remove(id);
        this.$toast.success(`Usuário removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível remover o Usuário.`, {
            timeout: 6000
          })
        }
      }
    },
	  async getPermissoes(){
      this.permiteCadastrar = await this.getPermissaoPorItemPerfil("Funcionario.cadastro",this.nivelUsuarioLogado);
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>